import React from 'react'

import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'
import Panel from '@cinch/oxd-components/panel/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './loading-panel.module.css'

const LoadingPanel: React.FC<{ i18n: { title: string } }> = ({ i18n: { title = '' } }) => (
  <Panel isBodyFlex={true}>
    <div className={styles.loadingPanel}>
      <Text oxford={true} className={styles.title} type={TextStyles.cardTitle} element="h3">
        {title}
      </Text>
      <LoadingSpinner size={parseInt(tokens.customProperties.spacing.xxl, 10)} />
    </div>
  </Panel>
)

export default LoadingPanel
